<template>
<section class="content">
    <div id="overlay"  v-if="loading">
      <div class="spinner"></div>
      <br/>
        <h4>Loading...</h4>
    </div>
    <div>
      <div class="box box-info">
        <form>
          <div class="p-fluid p-formgrid p-grid">
              <div class="p-field p-col-12 p-md-2">
               <label for="fromDate">From Date</label>
                 <date-picker v-model="fromDate" valueType="format" v-if="!englishDateEnabled"/>
                <InputMask mask="9999-99-99" type="text" v-else class="nepali-calendar" id="fromDate" v-model="fromDate"/>
              </div>

               <div class="p-field p-col-12 p-md-2">
                 <label for="toDate">To Date</label>
                 <date-picker v-model="toDate" valueType="format" v-if="!englishDateEnabled"/>
                 <InputMask mask="9999-99-99" type="text" v-else class="nepali-calendar" id="toDate" v-model="toDate"/>
              </div>

              <!-- <label for="voucher" class="col-sm-1 control-label">Voucher</label> -->
              <div class="p-field p-col-12 p-md-1 p-mt-5">
                 <Button type="submit"  @click.prevent="searchChallan"
                 class="p-button-raised" label="Search" icon="pi pi-search"/>
                 <!-- <button type="submit" style="margin-left:10px" v-if="this.employeeInventoryAssignList.length > 0"  @click.prevent="reset"
                 class="btn btn-info pull-left">Reset</button> -->
              </div>
               <div class="p-field p-col-12">
               <a href="#"  @click.prevent="exportCSV()" v-if="this.employeeInventoryAssignList.length > 0">
            <img src="../../../../../static/img/excel.png" style="float:right;height: 3em;width: 3em;"/>
         </a>
               </div>
          </div>
        </form>

       
       <DataTable :value="employeeInventoryAssignList"
      :paginator="true" ref="po"
      :rows="8" :filters="filters"
      class="p-datatable-responsive p-datatable-customers"
      data-key="id">
     <!-- <Column header="S.N" field="id"/> -->
      <Column header="Assign From" :sortable="true"
       field="assignDateNepali"  filterMatchMode="contains">
       <template #filter>
            <InputText type="text" class="p-column-filter" v-model="filters['assignDateNepali']" />
        </template>
      </Column>
       <Column header="AssignTo" :sortable="true" field="assignToDateNepali"  filterMatchMode="contains">
       <template #filter>
            <InputText type="text" class="p-column-filter" v-model="filters['assignToDateNepali']" />
        </template>
      </Column>
      <Column header="Assign No" :sortable="true"  field="assignNo"  filterMatchMode="contains">
      <template #filter>
            <InputText type="text" class="p-column-filter" v-model="filters['assignNo']" />
        </template>
      </Column>
      <Column header="Employee" :sortable="true" field="employee.name"  filterMatchMode="contains">
      <template #filter>
            <InputText type="text" class="p-column-filter" v-model="filters['employee.name']" />
        </template>
      </Column>
      <Column header="Contact Number" :sortable="true" field="contactNumber"  filterMatchMode="contains" >
      <template #filter>
            <InputText type="text" class="p-column-filter" v-model="filters['contactNumber']" />
        </template>
      </Column>
      <Column header="Store" :sortable="true" field="warehouse.name"  filterMatchMode="contains" >
       <template #filter>
            <InputText type="text" class="p-column-filter" v-model="filters['warehouse.name']" />
        </template>
       </Column>
        <Column header="Action" headerStyle="width:11em;">
        <template #body="slotProps">
          <Button icon="pi pi-pencil" @click="editInventoryAssign(slotProps.data)" v-if="enableEdit" class="p-button-raised p-button-success" />
          <Button icon="pi pi-pencil" @click="editInventoryAssign(slotProps.data)" v-else disabled class="p-button-raised p-button-success" />

          <Button v-if="enableDelete" @click="openDialog(slotProps.data.id)" class="p-button-raised p-button-danger" icon="pi pi-trash"/>
          <Button v-else disabled @click="openDialog(slotProps.data.id)" class="p-button-raised p-button-danger" icon="pi pi-trash"/>

          <Button class="p-button-raised" @click="viewPIVDetail(slotProps.data)" icon="pi pi-eye" />
          <!-- <Button class="p-button-raised p-button-warning"  icon="pi pi-print"/> -->
        </template>
      </Column>
       <template #empty>No record found</template>
     </DataTable>
    </div>
  </div>
  <Dialog v-model="dialogShow" @cancel="cancel" @deleted="deleteReport"/>
  </section>

</template>
<script>
import DatePicker from 'vue2-datepicker'
import DataTable from 'primevue/datatable'
import Column from 'primevue/column'
import Dialog from '../../../layout/dialog'
import globalKey from '../../../../store/globalKey'
import axios from 'axios'
import $ from 'jquery'
import InputText from 'primevue/inputtext'
import InputMask from 'primevue/inputmask'
import Button from 'primevue/button'
export default {
  name: 'InventoryAssignReport',
  data() {
    return {
      fromDate: null,
      toDate: null,
      loading: false,
      dialogShow: false,
      columnList: '',
      englishDateEnabled: true,
      filters: {},
      enableEdit: false,
      enableDelete: false
    }
  },
  mounted() {
    this.checkEnglish()
    if (!this.$store.getters.englishDate || this.$store.state.isEnglishDateEnabled === 'false') {
      this.nepaliDate()
    }
    if (!this.$store.getters.englishDate && this.salesChallan === undefined ||
      this.$store.state.isEnglishDateEnabled === 'false') {
      this.setNepaliDate()
    }
    if (this.$store.state.isEnglishDateEnabled && this.$store.state.isEnglishDateEnabled !== 'false') {
      this.setEnglishDate()
    }
    this.columnNames()
    this.checkEnableEdit()
    this.checkEnableDelete()
  },
  computed: {
    employeeInventoryAssignList() {
      return this.$store.state.hr.employeeInventoryAssignList
    }
  },
  methods: {
    async searchChallan() {
      let dat = {
        fromDate: this.fromDate,
        toDate: this.toDate
      }
      this.loading = !this.loading
      let resp = await this.$store.dispatch('loadInventoryAssignList', dat)
      this.loading = false
      if (resp.data.data.length <= 0) {
        this.$toast.add({severity: 'error', summary: '', detail: resp.data.message, life: 10000})
      } else {
        this.employeeInventoryAssignList = resp.data.data
      }
    },
    async viewPIVDetail(data) {
      let PIHdata = {
        id: data.id,
        warehouse: data.warehouse,
        employee: data.employee,
        assignFrom: data.assignFrom,
        assignTo: data.assignTo,
        assignFromDate: data.assignFromDate,
        assignToDate: data.assignToDate,
        assignNo: data.assignNo,
        remarks: data.remarks
      }
      this.$router.push({name: 'assign Detail Report', params: { purchaseHeaderObj: PIHdata }})
    },
    checkEnableEdit() {
      if (this.$store.getters.modules.includes(',5.07')) {
        this.enableEdit = true
      }
    },
    checkEnableDelete() {
      if (this.$store.getters.modules.includes(',5.11')) {
        this.enableDelete = true
      }
    },
    exportCSV() {
      let data = {
        fromDate: this.fromDate,
        toDate: this.toDate,
        columnList: this.columnList
      }
      axios({
        url: globalKey + '/fileDownload/excelReport/' + this.$store.getters.organisationId + '/' + this.$store.getters.userId + '/' + data.fromDate + '/' + data.toDate + '/purchaseChallan' + '/' + this.$store.getters.fyId + '/' + data.columnList,
        method: 'get',
        headers: { 'Accept': 'application/vnd.ms-excel', 'Authorization': localStorage.token },
        responseType: 'blob'
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]), {type: response.data.type})
        const link = document.createElement('a')
        const contentDisposition = response.headers['content-disposition']
        let fileName = 'purchaseChallan.xlsx'
        if (contentDisposition) {
          const fileNameMatch = contentDisposition.match(/filename="(.+)"/)
          if (fileNameMatch.length === 2) {
            fileName = fileNameMatch[1]
          }
        }
        link.href = url
        link.setAttribute('download', fileName)
        document.body.appendChild(link)
        link.click()
        link.remove()
        window.URL.revokeObjectURL(url)
      })
    },
    exportToPdf(SOHeaderId) {
      axios({
        url: globalKey + '/fileDownload/printPurchaseBill/' + SOHeaderId + '/purchaseChallan' + '/' + this.$store.getters.organisationId + '/' + this.$store.getters.userId,
        method: 'get',
        headers: { 'Accept': 'application/pdf', 'Authorization': localStorage.token },
        responseType: 'blob'
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]), {type: response.data.type})
        const link = document.createElement('a')
        const contentDisposition = response.headers['Content-Disposition']
        let fileName = 'purchaseChallan.pdf'
        if (contentDisposition) {
          const fileNameMatch = contentDisposition.match(/filename="(.+)"/)
          if (fileNameMatch.length === 2) {
            fileName = fileNameMatch[1]
          }
        }
        link.href = url
        link.setAttribute('download', fileName)
        document.body.appendChild(link)
        link.click()
        link.remove()
        window.URL.revokeObjectURL(url)
      })
    },
    columnNames() {
      for (let i = 0; i < this.$refs.po.columns.length; i++) {
        this.columnList += this.$refs.po.columns[i].header + ','
      }
    },
    async editInventoryAssign(data) {
      this.$router.push({name: 'Inventory Assign Entry', params: {inventoryAssignEntry: data}})
    },
    async deleteReport(value) {
      if (value.trim() === '') {
        this.$toast.add({severity: 'error', summary: '', detail: 'Delete reason cannot be empty!', life: 10000})
        this.dialogShow = true
        return
      }
      let deleteRe = {
        inventoryInHeaderId: this.accountId,
        deleteReason: value
      }
      let resp = await this.$store.dispatch('deletePurchaseChallan', deleteRe)
      if (resp.data.status === 'SUCCESS') {
        this.$toast.add({severity: 'error', summary: '', detail: resp.data.message, life: 10000})
        this.dialogShow = false
      } else {
        this.$toast.add({severity: 'error', summary: '', detail: resp.data.message, life: 10000})
        this.dialogShow = false
      }
    },
    cancel(data) {
      this.dialogShow = false
      this.show = false
    },
    // async editInventoryAssign(data) {
    //   let isEditData = {
    //     edit: data
    //   }
    //   this.$router.push({name: 'Inventory Assign Entry', params: { inventoryAssignEntry: isEditData }})
    // },
    openDialog(id) {
      this.dialogShow = true
      this.accountId = id
    },
    setEnglishDate() {
      this.fromDate = new Date().toISOString().slice(0, 10)
      this.toDate = new Date().toISOString().slice(0, 10)
    },
    checkEnglish() {
      if (this.$store.state.isEnglishDateEnabled === false || this.$store.state.isEnglishDateEnabled === 'false') {
        this.englishDateEnabled = true
        return
      } else {
        this.englishDateEnabled = false
        return
      }
    },
    setNepaliDate() {
      if (this.$store.getters.nepaliNewDate !== '') {
        this.fromDate = this.$store.getters.nepaliNewDate
        this.toDate = this.$store.getters.nepaliNewDate
      }
    },
    reset() {
      this.employeeInventoryAssignList = []
      if (!this.$store.getters.englishDate || this.$store.state.isEnglishDateEnabled === 'false') {
        this.fromDate = this.$store.getters.nepaliNewDate
        this.toDate = this.$store.getters.nepaliNewDate
      } else {
        this.fromDate = new Date().toISOString().slice(0, 10)
        this.toDate = new Date().toISOString().slice(0, 10)
      }
    },
    nepaliDate() {
      $('#fromDate').nepaliDatePicker({
        ndpYear: true,
        ndpMonth: true,
        ndpYearCount: 10,
        disableBefore: this.$store.state.startDate,
        disableAfter: this.$store.state.endDate,
        onChange: () => {
          this.fromDate = $('#fromDate').val()
        }
      })
      $('#toDate').nepaliDatePicker({
        ndpYear: true,
        ndpMonth: true,
        ndpYearCount: 10,
        disableBefore: this.$store.state.startDate,
        disableAfter: this.$store.state.endDate,
        onChange: () => {
          this.toDate = $('#toDate').val()
        }
      })
    }
  },
  components: {
    DatePicker,
    DataTable,
    Column,
    Dialog,
    InputText,
    InputMask,
    Button
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// InventoryAssignReport.vue?4fd58720